import {
  redirect,
} from "CommonCore/router-util";

import App from "App/app";
import Error404 from "CommonComponents/error404";
import {
  registeredRoutes,
} from "CommonCore/api";

import HomePage from "App/home-page";
import ProfilPage from "App/profil-page";
import "App/nutzer-bootstrap";

import PersonPage from "App/person-page";
import PersonStammTab from "App/person-stamm-tab";
import PersonStudienTab from "App/person-studien-tab";
import PersonLBVPersonTab from "App/person-lbvperson-tab";
import PersonLBVStatusTab from "App/person-lbvstatus-tab";
import PersonWeitereBVTab from "App/person-beschaeftigung-tab";

import MnListPage from "App/mn-list-page";
import MnDetailPage from "App/mn-detail-page";
import MnVorgesehenListPage from "App/mn-vorgesehen-list-page";
import MnVorgesehenDetailPage from "App/mn-vorgesehen-detail-page";

import AntragListPage from "App/antrag-list-page";
import AntragVerwaltenPage from "App/antrag-verwalten-page";
import AntragInfoWidget from "App/antrag-info-widget";
import AntragVerwaltenAntragstellerTab from "App/antrag-vw-antragsteller-tab";

import AntragStammTab from "App/antrag-stamm-tab";
import AntragTarifTab from "App/antrag-tarif-tab";
import AntragPersonalratTab from "App/antrag-pr-tab";
import AntragPruefvermerkTab from "App/antrag-pruefvermerk-tab";
import AntragStudienTab from "App/antrag-studien-tab";
import AntragLBVPersonTab from "App/antrag-lbvperson-tab";
import AntragLBVStatusTab from "App/antrag-lbvstatus-tab";
import AntragVerwaltenBeschaeftigungTab from "App/antrag-vw-beschaeftigung-tab";
import AntragVerträgeTab from "App/antrag-vertraege-tab";
import AntragDokumenteSbTab from "App/antrag-dokumente-sb-tab";

import AntragAnlagenTab from "App/antrag-anlagen-tab";
import AntragHistorieTab from "App/antrag-historie-tab";
import AntragMnEditor from "App/antrag-mn-editor";

import AenderungsmitteilungListPage from "App/aenderungen-list-page";
import AenderungenDetailPage from "App/aenderungen-detail-page";

import HelpPage from "App/help-page";
import HelpEditPage from "App/help-edit-page";
import ResetPage from "App/pwd-reset-page";
import DatenschutzPage from "App/datenschutz-page";

import ReportLehraufträge from "Auswertungen/report-lehraufträge";
import ReportLehraufträgeFK from "Auswertungen/report-lehraufträge-fk";

const antragChildren = [
  {
    path: ":currentAntrag",
    component: AntragVerwaltenPage,
    nestedChildren: true,
    indexRoute: redirect("deckblatt"),
    childRoutes: [
      {
        path: "deckblatt",
        indexRoute: { component: AntragInfoWidget },
        childRoutes: [
          {
            path: "massnahme/:currentMassnahme",
            component: AntragMnEditor,
          },
        ],
      },
      // Tab für Antragsteller
      {
        path: "antragsteller",
        component: AntragVerwaltenAntragstellerTab,
      },

      // Tab-Liste für Verwaltung
      {
        path: "stamm",
        component: AntragStammTab,
      },
      {
        path: "tarif",
        component: AntragTarifTab,
      },
      {
        path: "personalrat",
        component: AntragPersonalratTab,
      },
      {
        path: "pruefvermerk",
        component: AntragPruefvermerkTab,
      },

      {
        path: "studium",
        component: AntragStudienTab,
      },
      {
        path: "steuer",
        component: AntragLBVPersonTab,
      },
      {
        path: "status",
        component: AntragLBVStatusTab,
      },
      {
        path: "weiterebv",
        component: AntragVerwaltenBeschaeftigungTab,
      },
      {
        path: "anlagen",
        component: AntragAnlagenTab,
      },
      {
        path: "dokumente_sb",
        component: AntragDokumenteSbTab,
      },
      {
        path: "historie",
        component: AntragHistorieTab,
      },
      {
        path: "vertraege",
        component: AntragVerträgeTab,
      },
    ],
  },
];

export const routes = [
  {
    path: "/",
    component: App,
    indexRoute: { component: HomePage },
    nestedChildren: true,
    childRoutes: [
      {
        path: "profil",
        component: ProfilPage,
      },
      {
        path: "person",
        component: PersonPage,
        nestedChildren: true,
        childRoutes: [
          {
            path: "stamm",
            component: PersonStammTab,
          },
          {
            path: "studium",
            component: PersonStudienTab,
          },
          {
            path: "steuer",
            component: PersonLBVPersonTab,
          },
          {
            path: "status",
            component: PersonLBVStatusTab,
          },
          {
            path: "weiterebv",
            component: PersonWeitereBVTab,
          },
        ],
      },
      {
        path: "massnahmevorgesehen",
        indexRoute: { component: MnVorgesehenListPage },
        childRoutes: [
          {
            path: ":currentMassnahmevorgesehen",
            component: MnVorgesehenDetailPage,
          },
        ],
      },
      {
        path: "massnahme",
        indexRoute: { component: MnListPage },
        childRoutes: [
          {
            path: ":currentMassnahme",
            component: MnDetailPage,
          },
        ],
      },

      {
        path: "aenderungsmitteilung",
        indexRoute: { component: AenderungsmitteilungListPage },
        childRoutes: [
          {
            path: ":currentAenderungsmitteilung",
            component: AenderungenDetailPage,
          },
        ],
      },

      {
        path: "/antrag",
        indexRoute: { component: AntragListPage },
        childRoutes: antragChildren,
      },
      {
        path: "/vertrag", // Unterscheidung findet im Plugin aufgrudn der Route  statt
        indexRoute: { component: AntragListPage },
        childRoutes: antragChildren,
      },

      {
        path: "hilfe/new",
        component: HelpEditPage,
      },
      {
        path: "hilfe/:currentHilfe",
        component: HelpEditPage,
      },
      {
        path: "hilfe",
        component: HelpPage,
      },
      {
        path: "/datenschutz",
        component: DatenschutzPage,
      },

      {
        path: "/pwvergessen",
        component: ResetPage,
      },
      {
        path: "/auswertung/lehraufträge",
        component: ReportLehraufträge,
      },
      {
        path: "/auswertung/lehraufträge_fk",
        component: ReportLehraufträgeFK,
      },

      ...registeredRoutes,

      { path: "*", component: Error404 },
    ],
  },
];
